import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { GOOGLE_MAP_API_KEY, MAP_DEFAULT_CENTER } from "../consts";
import { APIProvider } from "@vis.gl/react-google-maps";
import GMap from "./GMap";

const PolygonView = (props) => {
  const [showPolygon, setShowPolygon] = useState(false);
  return (
    <div>
      <h3 onClick={() => setShowPolygon(true)} className="request1GIS">
        View Polygon
      </h3>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showPolygon}
        onHide={() => {
          setShowPolygon(false);
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="h5 text-primary border-0 pb-0"
            id="contained-modal-title-vcenter"
          >
            Polygon Map
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="map-modal">
            <APIProvider apiKey={GOOGLE_MAP_API_KEY}>
              <GMap
                polygonPositionsArray={[
                  { polygonArray: props?.polygonData || [], color: "red" },
                ]}
                mapCenter={
                  props?.polygonData &&
                  props?.polygonData?.length &&
                  props?.polygonData[0]
                    ? props?.polygonData[0]
                    : MAP_DEFAULT_CENTER
                }
              ></GMap>
            </APIProvider>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PolygonView;
